export default __webpack_public_path__ + "assets/fonts/d1e402c13e37e9678a565df73ba52922.ttf";